import useUserInfo from "hooks/useUserInfo";
import {LoginBoxProps, OtherLoginMethodType} from "types/types";
import React, {PropsWithChildren, useMemo, useState} from "react";
import {
    EmailIcon,
    GoogleIcon,
    TelegramIcon,
    WalletIcon,
    XIcon,
    ArrowRightIcon,
    GithubIcon,
    DiscordIcon,
    LinkedinIcon,
    FacebookIcon,
    ArrowDownIcon,
    EVMDarkIcon,
    EVMLightIcon,
    SOLDarkIcon,
    SOLLightIcon,
    YoutubeIcon,
    BTCDarkIcon,
    BTCLightIcon,
    TRXDarkIcon, TRXLightIcon, TonDarkIcon, TonLightIcon
} from "assets/icon";
import EmailModal from "../EmailModal";
import {FormattedMessage, useIntl} from "react-intl";
import {useDownMd} from "../../hooks/useLayout";
import {DEFAULT_WALLET_METHODS, useWalletConfig, WALLET_METHODS} from "../../hooks/useConfig";
import useAppConfig from "../../hooks/useAppConfig";

export const RecommendItem = ({
                                  icon,
                                  name,
                                  onClick,
                                  showChildren = false,
                                  children,
                                  footer
                              }: {
    icon: React.ReactNode,
    name: string,
    onClick: () => void,
    showChildren?: boolean
    footer?: React.ReactNode
} & PropsWithChildren) => {
    return <div className="matchid-login-recommend-method">
        <div className="matchid-login-recommend-method-item" onClick={onClick}>
            <div className="matchid-login-recommend-method-content">
                <div className="matchid-login-recommend-method-icon">
                    {icon}
                </div>
                <span className="matchid-login-recommend-method-name">{name}</span>
            </div>
            {
                footer ? footer : children ? <ArrowDownIcon
                        className={`matchid-login-recommend-method-arrow ${showChildren ? 'matchid-login-recommend-method-arrow-active' : ''}`}
                        size={20}
                        color={"var(--matchid-arrow-color)"}/> :
                    <ArrowRightIcon className="matchid-login-recommend-method-arrow" size={20}
                                    color={"var(--matchid-arrow-color)"}/>
            }

        </div>
        {children && <div
            className={`matchid-login-recommend-method-popover ${showChildren ? 'matchid-login-recommend-method-popover-active' : ''}`}>
            {children}
        </div>}
    </div>
}
export default function LoginBox({
                                     recommendMethods,
                                     methods ,
                                     walletMethods ,
                                     inModal = false
                                 }: LoginBoxProps) {

    const config = useAppConfig()
    const methodConfig = useMemo(()=>{
        if(recommendMethods||methods||walletMethods){
            return {
                recommendMethods:recommendMethods?recommendMethods:(walletMethods?['wallet']:[]),
                methods:methods||[],
                walletMethods:walletMethods||[]
            }
        }
        if(!config.platform){
            return {
                recommendMethods:[],
                methods:[],
                walletMethods:[]
            }
        }
        const platform = config.platform.map(p=>{
            // @ts-ignore
            if(p=='x'||p=='X'){
                return 'twitter'
            }
            return p.toLowerCase()
        })
        console.log('platform',platform)
        const walletMethodList = WALLET_METHODS.filter(m=>platform.includes(m))
        let recommendMethodList = walletMethodList.length>0?['wallet']:[]
        let methodList:any[] = []
        const otherMethodList = platform.filter(m=>!walletMethodList.includes(m as any))
        if(otherMethodList.length>0){
            const recommendMethodListLength = recommendMethodList.length
            const maxRecommendMethodListLength = 3
            if(recommendMethodListLength<maxRecommendMethodListLength){
                recommendMethodList = recommendMethodList.concat(otherMethodList.slice(0,Math.min(maxRecommendMethodListLength-recommendMethodListLength,otherMethodList.length)))
                methodList = otherMethodList.slice(maxRecommendMethodListLength-recommendMethodListLength)
            }else{
                methodList = otherMethodList
            }
        }
        return {
            recommendMethods:recommendMethodList,
            methods:methodList,
            walletMethods:walletMethodList
        }
    },[config.platform,recommendMethods,methods,walletMethods])

    const [emailOpen, setEmailOpen] = useState(false)
    const {login} = useUserInfo()
    const [showWallet, setShowWallet] = useState(false)
    const intl = useIntl()
    const isDownMd = useDownMd()
    const methodMap: {
        [key: string]: {
            icon: React.ReactNode,
            name: string,
            onClick: () => void,
            type?: "wallet"
        }
    } = {
        wallet: {
            icon: <WalletIcon size={isDownMd ? 36 : 40}/>,
            name: intl.formatMessage({id: "wallet"}),
            onClick: () => setShowWallet(!showWallet),
            type: "wallet"
        },
        email: {
            icon: <EmailIcon size={isDownMd ? 36 : 40}/>,
            name: intl.formatMessage({id: "email"}),
            onClick: () => {
                setEmailOpen(true)
            }
        },
        google: {
            icon: <GoogleIcon size={isDownMd ? 36 : 40}/>,
            name: "Google",
            onClick: () => login('google')
        },
        twitter: {
            icon: <XIcon size={isDownMd ? 36 : 40}/>,
            name: "X",
            onClick: () => login('twitter')
        },
        telegram: {
            icon: <TelegramIcon size={isDownMd ? 36 : 40}/>,
            name: "Telegram",
            onClick: () => login('telegram')
        },
        github: {
            icon: <GithubIcon size={isDownMd ? 36 : 40}/>,
            name: "Github",
            onClick: () => login('github')
        },
        discord: {
            icon: <DiscordIcon size={isDownMd ? 36 : 40}/>,
            name: "Discord",
            onClick: () => login('discord')
        },
        linkedin: {
            icon: <LinkedinIcon size={isDownMd ? 36 : 40}/>,
            name: "LinkedIn",
            onClick: () => login('linkedin')
        },
        facebook: {
            icon: <FacebookIcon size={isDownMd ? 36 : 40}/>,
            name: "Facebook",
            onClick: () => login('facebook')
        },
        youtube: {
            icon: <YoutubeIcon size={isDownMd ? 36 : 40}/>,
            name: "Youtube",
            onClick: () => login('youtube')
        }

    }

   const {walletMap} = useWalletConfig()


    return <>
        {(!inModal || !emailOpen) && <div className="matchid-login-box">
            <div className="matchid-login-recommend-list">
                {
                    methodConfig.recommendMethods.map((m) => {
                        return <RecommendItem
                            icon={methodMap[m]?.icon}
                            name={methodMap[m]?.name}
                            onClick={methodMap[m]?.onClick}
                            key={m}
                            showChildren={m == 'wallet' && showWallet}
                        >
                            {
                                m == 'wallet' && <>
                                    <div className={"matchid-login-recommend-wallet-divider"}></div>
                                    <div className={"matchid-login-recommend-wallet-list"}>
                                        {
                                            methodConfig.walletMethods.map((n) => {
                                                const m = walletMap[n]
                                                return <div className={"matchid-login-recommend-wallet-item"}
                                                            key={m.name}
                                                            onClick={()=>{
                                                                login(m.method)
                                                            }}>
                                                    <div className={"matchid-login-recommend-wallet-item-content"}>
                                                        <div className={"matchid-login-recommend-wallet-item-icon"}>
                                                            {m.icon}
                                                        </div>
                                                        <div
                                                            className={"matchid-login-recommend-wallet-item-hover-icon"}>
                                                            {m.activeIcon}
                                                        </div>

                                                        <span
                                                            className={"matchid-login-recommend-wallet-item-name"}>{m.name}</span>
                                                    </div>
                                                    <ArrowRightIcon
                                                        className="matchid-login-recommend-wallet-item-arrow"
                                                        size={20}
                                                        color={"var(--matchid-arrow-color)"}/>
                                                </div>
                                            })
                                        }
                                    </div>
                                </>
                            }
                        </RecommendItem>
                    })
                }
            </div>
            {methodConfig.methods.length > 0 &&
                <div className="matchid-login-other">
                    <div className="matchid-login-other-text"><FormattedMessage id={"otherLoginMethods"}/></div>
                    <div className="matchid-login-method-box">
                        {
                            methodConfig.methods.map((m) => {
                                return <div className="matchid-login-method-item" key={m}
                                            onClick={methodMap[m]?.onClick} title={methodMap[m]?.name}>
                                    {methodMap[m]?.icon}
                                </div>
                            })
                        }
                    </div>
                </div>
            }
        </div>
        }
        <EmailModal
            isOpen={emailOpen}
            onClose={() => {
                setEmailOpen(false)
            }}
            onBack={inModal ? () => {
                setEmailOpen(false)
            } : undefined}
        />
    </>

}
